export enum AggregateTypeEnum {
    average = "AVERAGE",
    sum = "SUM",
    individualathlete = "ATHLETE",
}
